import { useState } from "react";

const reviews = [
  {
    id: 1,
    name: "Jon R.",
    location: "CT",
    rating: 5,
    text: "Honestly great service, Paul is amazing, goes out his way to get the job done. Has amazing communication and is quick. I haven't had proper working boiler in 2 months, they came in and had worked better than anyone else who has touched this system. Will be coming back!!!!!",
  },
  {
    id: 2,
    name: "Mary M.",
    location: "CT",
    rating: 5,
    text: "This company is the most professional and friendly I\'ve ever had at my house! Elderly and handicapped we had no heat and Paul the owner came right out and got us heat! They are going to be our new HVAC company from here on out!",
  },
  {
    id: 3,
    name: "James L.",
    location: "Meriden, CT",
    rating: 5,
    text: "Paul and his team are great to work with. The whole process and installation of our new mini split system was seamless from start to finish. They are on time, professional, great pricing, excellent service. I highly recommend them for all your heating and cooling needs.",
  },
  {
    id: 4,
    name: "Celine S.",
    location: "CT",
    rating: 5,
    text: "Paul and his staff helped me out when my water heater started leaking, he fixed it within the same day I call and has very affordable pricing. Thank you Paul",
  },
  {
    id: 5,
    name: "Ryan A.",
    location: "CT",
    rating: 5,
    text: "Highly recommend them for their plethora of skills, craftsmanship and job knowledge. Definitely the go to spot if you want things done right with care the first time.",
  },
  {
    id: 6,
    name: "Brenda F.",
    location: "CT",
    rating: 5,
    text: "PJ, the owner, is the best guy! Communicative, honest, and always fair!",
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i key={i} className={`ri-star-fill text-sm ${i < count ? "text-amber-400" : "text-gray-200"}`}></i>
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  const [current, setCurrent] = useState(0);
  const perPage = 3;
  const pages = Math.ceil(reviews.length / perPage);
  const visible = reviews.slice(current * perPage, current * perPage + perPage);

  return (
    <section className="py-16 md:py-20 bg-[#F0F4FA]">
      <div className="max-w-6xl mx-auto px-5 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-4 gap-3 md:gap-4">
          <div>
            <span className="text-[#C8102E] text-xs font-bold tracking-[0.2em] uppercase">REVIEWS</span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#0B2447] mt-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              What Our Customers Say
            </h2>
          </div>
          {/* Average */}
          <div className="flex items-center gap-2 md:gap-3">
            <StarRating count={5} />
            <span className="text-[#0B2447] font-bold text-sm">5.0 / 5.0</span>
            <span className="text-gray-400 text-xs hidden sm:inline">(7+ Reviews)</span>
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-google-fill text-xl text-[#ea4335]"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mt-6 md:mt-8">
          {visible.map((review) => (
            <div key={review.id} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100">
              <StarRating count={review.rating} />
              <p className="mt-3 md:mt-4 text-sm text-gray-600 leading-relaxed">&ldquo;{review.text}&rdquo;</p>
              <div className="mt-4 pt-3 md:pt-4 border-t border-gray-100 flex items-center justify-between">
                <div>
                  <p className="text-sm font-bold text-[#0B2447]">{review.name}</p>
                  <p className="text-xs text-gray-400 flex items-center gap-1 mt-0.5">
                    <i className="ri-map-pin-line text-[#C8102E]"></i>
                    {review.location}
                  </p>
                </div>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-google-fill text-lg text-[#ea4335]"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-2 mt-6 md:mt-8">
          {Array.from({ length: pages }).map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`cursor-pointer transition-all rounded-full ${i === current ? "bg-[#C8102E] w-6 h-2.5" : "bg-gray-300 w-2.5 h-2.5"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
